export default {
  // スタック
  stack: [],

  // 現在の位置
  index: -1
}
